import { createContext, Dispatch, SetStateAction } from 'react';
import { IHeroSectionData } from './heroSectionContextInterfaces';

export const HeroSectionDataContext = createContext<IHeroSectionData>({
  imagePath: '',
});

export const HeroSectionMutatorContext = createContext<Dispatch<SetStateAction<IHeroSectionData>>>(
  () => {},
);
